// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer-footer_root__h4A5G"};